import { atom } from 'recoil';
import { ATOM_KEYS } from 'utils/const/recoilKeys';
// Types
import { EntryUsers } from 'types/lottery/entryUsers';

export const entryUsersState = atom<EntryUsers[]>({
  key: ATOM_KEYS.ENTRY_USERS_STATE,
  default: [],
});
